import {Observable} from 'rxjs/Rx';
import {HttpResponse} from '@angular/common/http';
import {EndpointConfig} from '../../src/lib/Service/Impl/EndpointConfig';
import {Callable} from '../../src/lib/Service/Interface/Callable';
export class EndpointCallerMock implements Callable {
    config: EndpointConfig = {baseUri: ''};
    mockResponse           = {};
/**
 * @param {?} absoluteUrl
 * @param {?} method
 * @param {?=} requestData
 * @return {?}
 */
public call(absoluteUrl: string, method: string, requestData: any = {}): Observable<HttpResponse<any> | any> {
        return Observable.of(this.mockResponse);
    }
}

function EndpointCallerMock_tsickle_Closure_declarations() {
/** @type {?} */
EndpointCallerMock.prototype.config;
/** @type {?} */
EndpointCallerMock.prototype.mockResponse;
}

